import { Route } from '@angular/router';
import {
  AppConfig,
  authGuard,
  CadastrarComponent,
  EditarComponentComponent,
  loggedInGuard,
  LoginComponent,
  PessoaMinhaContaComponent,
  RecuperarSenhaComponent,
  SistemaEnum,
} from '@nomoh-monorepo/shared-common-ui';
import { NxWelcomeComponent } from './nx-welcome.component';

const BARDO_CLIENT_CONFIG: AppConfig = {
  app: 'bardo-cliente',
  title: 'Bardo Cliente',
  theme: 'bardo-client-theme',
  dashboardRoute: '/booking',
  sistema: SistemaEnum.Bardo,
};

export const appRoutes: Route[] = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loggedInGuard],
    data: { appConfig: BARDO_CLIENT_CONFIG },
  },
  {
    path: 'recuperar-senha',
    component: RecuperarSenhaComponent,
    data: { appConfig: BARDO_CLIENT_CONFIG },
  },
  {
    path: 'cadastrar',
    component: CadastrarComponent,
    data: { appConfig: BARDO_CLIENT_CONFIG },
  },
  {
    path: 'minha-conta/:pessoaId',
    component: PessoaMinhaContaComponent,
    data: { appConfig: BARDO_CLIENT_CONFIG },
  },
  {
    path: 'editar/:id',
    component: EditarComponentComponent,
    data: { appConfig: BARDO_CLIENT_CONFIG },
  },
  {
    path: 'privacidade',
    loadComponent: () =>
      import('@nomoh-monorepo/shared-common-ui').then(
        (m) => m.PrivacidadeComponent
      ),
    data: { systemName: 'Bardo Cliente' },
  },
  {
    path: 'plano-expirado',
    loadComponent: () =>
      import('@nomoh-monorepo/shared-common-ui').then(
        (m) => m.PlanoExpiradoComponent
      ),
  },
  {
    path: '',
    canActivate: [authGuard],
    children: [
      { path: 'booking', component: NxWelcomeComponent },
      { path: '', redirectTo: '/booking', pathMatch: 'full' },
    ],
  },
];
